module.exports = __webpack_public_path__ + "res/img/wechat_mask_android.a8e790b1.png";